import { useAppConfig } from 'hooks';
import { useTranslation } from 'react-i18next';
import { AppModule } from 'types';

export const useSidebar = () => {
  const { protectedRoutes } = useAppConfig();
  const { t } = useTranslation();

  const getMenuItemsByModule = (...modules: AppModule[]) => {
    return protectedRoutes
      .filter(x => modules.includes(x.module as AppModule) && x.menu)
      .map(x => ({
        link: x.path,
        title: t(x.menu?.title as string),
        icon: x.menu?.icon,
      }));
  };

  const accountManagementModules = [
    AppModule.ACCOUNT_MANAGEMENT,
    AppModule.USERS,
    AppModule.BILLING,
  ];

  return {
    getMenuItemsByModule,
    accountManagementModules,
  };
};
